export const E_DOCUMENT_FILTER = 'type=EDocument'
export const E_INVOICING_ENTRY_URL = 'eInvoicingEntryUrl'
